import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class BranchFieldsService {

  constructor(private httpClient: HttpClient) {
  }

  getBranchFieldsMeta(): Observable<any> {
    const url = `branches/custom-field-sections`;
    return this.httpClient.get(`${environment.API_ENDPOINT}${url}`);
  }
}
